import classes from "./Header2.module.css";
import { FaHouse, FaFutbol, FaTrophy, FaClock } from "react-icons/fa6";
import { FaUser } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';

const Header2 = ({ active, hide }) => {
    const navigate = useNavigate();

    return (
        <header className={classes.header}>
            {/* Logo strip */}
            <div className={classes.logoStrip}>
                <div className={classes.logoInner}>
                    <img src="/assets/images/logo.png" alt="logo" className={classes.logo_img} />
                    {/* <span className={classes.logoEmoji}>⚽</span>
                    <span className={classes.logoWordmark}>
                        <em>Football</em> Masters
                    </span> */}
                </div>
                {/* Decorative pitch line */}
                <div className={classes.pitchLine} />
            </div>

            {/* Nav strip */}
            {!hide && (
                <nav className={classes.nav}>
                    <div className={classes.navInner}>
                        {[
                            { icon: FaHouse,   label: "Home",        path: "/home",        id: 0 },
                            { icon: FaFutbol,  label: "My Matches",  path: "/my-matches",  id: 1 },
                            { icon: FaClock,   label: "Live",        path: "/live",        id: 2 },
                            { icon: FaTrophy,  label: "Leaderboard", path: "/leaderboard", id: 3 },
                            { icon: FaUser,    label: "Profile",     path: "/profile",     id: 4 },
                        ].map(({ icon: Icon, label, path, id }) => (
                            <button
                                key={id}
                                type="button"
                                className={`${classes.navItem} ${active === id ? classes.navItemActive : ''}`}
                                onClick={() => navigate(path)}
                            >
                                <Icon className={classes.navIcon} />
                                <span className={classes.navLabel}>{label}</span>
                                {active === id && <span className={classes.activePill} />}
                            </button>
                        ))}
                    </div>
                </nav>
            )}
        </header>
    );
}

export default Header2;